import { Injectable } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { SmsTimerService } from '../../../../services/sms-timer.service';
import { finalize } from 'rxjs/operators';
import { RecoveryService } from '../../../services/recovery.service';
import { BaseMode } from './base-mode';
import { RequestIdService } from '../../../services/request-id.service';
import { Router } from '@angular/router';
import { ErrorModel } from '../../../../api';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Injectable({
  providedIn: 'root'
})
export class RecoveryMode extends BaseMode {
  public title: string = this.i18n('Создание (восстановление) пароля');
  public startUrl: string = '/auth/recovery-password';

  constructor(
    private authService: AuthService,
    private requestIdService: RequestIdService,
    private smsTimerService: SmsTimerService,
    private recoveryService: RecoveryService,
    private router: Router,
    private i18n: I18n
  ) {
   super();
  }

  submit(value) {
    this.loadingSubject.next(true);

    this.recoveryService.confirmation(value)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe(() => {
        this.router.navigate(['auth/recovery-password-details']).then(() => {
          this.requestIdService.reset();
        });
      }, (err: ErrorModel) => {
        this.errorSubject.next(err);
      });
  }

  repeat() {
    this.repeatLoadingSubject.next(true);

    this.recoveryService.checkPhone(this.requestIdService.value.phoneNumber)
      .pipe(finalize(() => this.repeatLoadingSubject.next(false)))
      .subscribe(data => {
        this.smsTimerService.onSmsTimer(this.requestIdService.value.time);
      });
  }
}
